let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4kAUE")).then(() => parcelRequire('1JGUg'));